{
  "title": "Valeur nette",
  "table": "Tableau",
  "chart": "Graphique en barres",
  "accordion": "Accordéon",
  "assets": "Actifs",
  "liabilities": "Passifs",
  "currentNetWorth": "Valeur nette actuelle",
  "downloadProgressTitle": "Données sur la valeur nette des emballages",
  "lastUpdated": "Dernière mise à jour",
  "accountSourceType": {
    "INTERNAL": "INTERNE",
    "EXTERNAL": "EXTERNE"
  },
  "categories": {
    "INTERNAL": "Investissements internes",
    "CASH": "Argent",
    "EXTERNAL_INVESTMENT_ACCOUNT": "Investissements externes",
    "REAL_ESTATE": "Immobilier",
    "VEHICLES": "Véhicules",
    "VALUABLES": "Objets de valeur",
    "OTHER_ASSET": "Autre",
    "LOANS": "Prêts",
    "MORTGAGE": "Hypothèque",
    "CREDIT_CARD": "Carte de crédit",
    "OTHER_LIABILITY": "Autre"
  },
  "netWorthTable": {
    "financialAccounts": "Comptes financiers",
    "asset": "Actif",
    "liability": "Passif",
    "noNetWorthData": "Aucune donnée sur la valeur nette trouvée",
    "total": "Total :",
    "downloadColumns": {
      "accountId": "Identifiant du compte",
      "firstName": "Prénom de l'utilisateur",
      "lastName": "Nom de famille de l'utilisateur",
      "entityName": "Nom de l'entité",
      "accountType": "Type de compte",
      "accountNickname": "Pseudonyme du compte",
      "value": "Valeur",
      "source": "Source",
      "category": "Catégorie",
      "organization": "Organisation",
      "user": "Utilisateur"
    }
  },
  "editNetWorth": {
    "title": "Modifier un actif ou un passif",
    "type": "Type",
    "accountNickname": "Pseudonyme du compte",
    "value": "Valeur",
    "delete": "Supprimer",
    "save": "Enregistrer",
    "deleteConfirmation": {
      "title": "Supprimer le compte {{accountName}}?",
      "bodyText": "Êtes-vous sûr(e) de vouloir supprimer cet élément?"
    }
  },
  "netWorthAccordion": {
    "noNetWorthData": "Aucune donnée sur la valeur nette trouvée"
  },
  "netWorthChart": {
    "emptyChart": "Aucune donnée trouvée"
  },
  "addNetWorthManually": {
    "title": "Ajouter un compte manuel",
    "nickname": "Pseudonyme",
    "value": "Valeur",
    "currency": "Devise",
    "currencies": {
      "USD": "Dollar américain",
      "CAD": "Dollar canadien"
    }
  },
  "addNetWorthAutomatically": {
    "linkingTimeInfo": "L'association peut prendre jusqu'à 5 minutes...",
    "noIntegration": "Aucune intégration trouvée",
    "linkSuccess": "Association réussie",
    "linkError": "Échec de l'association",
    "netWorthAutomaticLink": {
      "title": "Association de la valeur nette",
      "syncMessage": "Vos comptes sont en cours de synchronisation.",
      "notificationMessage": "Vous serez averti lorsque les comptes seront prêts.",
      "notificationSuccessTitle": "Comptes Plaid synchronisés.",
      "notificationSuccessBody": "Votre valeur nette est mise à jour.",
      "notificationFailureTitle": "Échec de la synchronisation des comptes Plaid.",
      "notificationFailureBody": "Veuillez réessayer.",
      "notificationLinkText": "Merci"
    }
  }
}
